import { computed } from 'mobx';
import ArrayListenerState from '../abstract/ArrayListenerState';
import TenancyState from './TenancyState';

class TenanciesBaseState extends ArrayListenerState {
  constructor(root, { expression, ...restOptions }) {
    super(root, {
      expression,
      // expression: () => this.parent.data?.tenancyUids,
      ItemClass: TenancyState,
      ...restOptions,
    });
  }

  get pastTenancies() {
    if (!this.isInitialized) return [];

    return this.data.filter(({ isPast }) => isPast);
  }

  get activeTenancies() {
    if (!this.isInitialized) return [];

    return this.data.filter(({ isActive }) => isActive);
  }
}

TenanciesBaseState.annotations = {
  ...ArrayListenerState.annotations,
  pastTenancies: computed,
  activeTenancies: computed,
};

export default TenanciesBaseState;
